import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// components
import ProductReviewRatingStars from 'features/productReviews/components/ProductReviewRatingStars';

// styles
import './ProductSearchUGCResultsCard.scss';

const ProductSearchUGCResultsCard = ({
	detail, productTitle, productCategory, handleClickDetail, searchTerm
}) => {

	const {
		rating, text, title, ugcType
	} = detail;

	const searchTermRegex = new RegExp(searchTerm, 'gi');

	const highLightedTitle =		(ugcType === 'review' || ugcType === 'article') && title !== ''
		? title?.toString().replace(searchTermRegex, '<b>$&</b>')
		: text?.toString().replace(searchTermRegex, '<b>$&</b>');

	const renderCardTypeText = () => {

		switch (ugcType) {

			case 'article':
				return `Knowledge base article for ${productCategory}`;
			case 'review':
				return `Review for ${productTitle}`;
			case 'question':
				return `Question for ${productTitle}`;
			default:
				console.warning(`Unable to render result text: wrong ugc type (${ugcType}) provided to component`);
				return '';

		}

	};

	return (
		<button
			type="button"
			className={classNames('ProductSearchUGCResultsCard', {
				'ProductSearchUGCResultsCard--review': ugcType === 'review'
			})}
			onClick={() => {

				if (typeof handleClickDetail === 'function') {

					handleClickDetail(detail);

				}

			}}
		>
			<div className="ProductSearchUGCResultsCard__body">
				<div className="ProductSearchUGCResultsCard__content">
					<span
						className="ProductSearchUGCResultsCard__title"
						dangerouslySetInnerHTML={{ __html: highLightedTitle }}
					/>

					{Boolean(rating) && (
						<div className="ProductSearchUGCResultsCard__starContainer">
							<ProductReviewRatingStars rating={rating} size="small" />
						</div>
					)}
					<div className="ProductSearchUGCResultsCard__cardTypeText">
						{renderCardTypeText()}
					</div>
				</div>
				<div className="lpIcon-scrollright ProductSearchUGCResultsCard__rightIcon" />
			</div>
		</button>
	);

};

ProductSearchUGCResultsCard.propTypes = {
	detail: PropTypes.shape({
		id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
		rating: PropTypes.number,
		text: PropTypes.string.isRequired,
		title: PropTypes.string,
		ugcType: PropTypes.string.isRequired
	}),
	productTitle: PropTypes.string.isRequired,
	productCategory: PropTypes.string.isRequired,
	handleClickDetail: PropTypes.func,
	searchTerm: PropTypes.string
};

export default ProductSearchUGCResultsCard;
